/**
 * Stores build information. The string literals are replaces at compile time by `set_version.js`.
 */
export const buildInfo = {
    versionNumber: "0.1.0",
    versionName: "nightly 2023-05-26",
    versionChannel: "nightly",
    buildDate: "2023-05-26T00:23:58.942Z",
    commitHash: "6d76e9669c54f7712ba4273d15e90f5683160955",
};
